import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { formattaData } from "../../../utils/functions/date-utils";
import { t } from "i18next";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";

const NewsDetailPage = () => {
  const { state } = useLocation();
  const { imageUrl, title, text, date } = state;

  const navigate = useNavigate();

  const colorPrimary = useSelector((state) => state.app.primaryColor);

  function renderText(testoHTML) {
    return <div dangerouslySetInnerHTML={{ __html: testoHTML }} />;
  }

  return (
    <div className="flex flex-col">
      <div className="flex items-center">
        <CoreBack />
        <div className="w-full flex flex-col items-center">
          <h3 className="text-center m-0">{title}</h3>
          <p className="m-0 font-bold " style={{ color: colorPrimary }}>
            {formattaData(date)}
          </p>
        </div>
      </div>

      <div className="w-full h-96  mt-5">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt=""
            width="100%"
            height="100%"
            style={{
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : (
          <div className="w-full h-full flex justify-center items-center bg-neutral-50">
            <p className="text-gray">{t("NoImg")}</p>
          </div>
        )}
      </div>
      {renderText(text)}
    </div>
  );
};

export default NewsDetailPage;
